import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import { Layout } from "antd";
import "antd/dist/antd.css";
import "./index.css";
import App from "./App";
import SideBar from "./Components/SideBar";
import * as serviceWorker from "./serviceWorker";
import Product from "./Components/Products/Product";
import NewProduct from "./Components/Products/NewProduct";
import ProductsDataView from "./Components/Products/ProductsDataView";
import CategoriesDataView from "./Components/Categories/CategoriesDataView";
import Category from "./Components/Categories/Category";
import NewCategory from "./Components/Categories/NewCategory";
import ManufacturersDataView from "./Components/Manufacturers/ManufacturersDataView";
import Manufacturer from "./Components/Manufacturers/Manufacturer";
import PagesDataView from "./Components/Pages/PagesDataView";
import Page from "./Components/Pages/Page";
import WrappedLoginForm from "./Components/Authentication";
import AppBar from "./Components/AppBar";
import Cookie from "js-cookie";
import SpecsDataView from "./Components/Products/SpecsDataView";
import PostsDataView from "./Components/Posts/PostsDataView";
import Post from "./Components/Posts/Post";
import Orders from "./Components/Orders";
import Banners from "./Components/Banners/Banners";
import Settings from "./Components/Settings/Settings";
import packageJson from "../package.json";

const { Footer, Content } = Layout;

const routing = (
  <Suspense fallback={<div>Loading...</div>}>
    <Router>
      <div id="routepage">
        <Layout style={{ minHeight: "100vh" }}>
          <SideBar />
          <Layout style={{ marginLeft: 200 }}>
            <AppBar />
            <Route
              render={() => (
                <Layout>
                  <Content>
                    <Switch>
                      <Route path="/login" component={WrappedLoginForm} />
                      <Route
                        exact
                        path="/"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <App />;
                          }
                        }}
                      />
                      <Route
                        path="/products"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <ProductsDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/product"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Product />;
                          }
                        }}
                      />
                      <Route
                        path="/newproduct"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <NewProduct />;
                          }
                        }}
                      />
                      <Route
                        path="/categories"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <CategoriesDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/category"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Category />;
                          }
                        }}
                      />
                      <Route
                        path="/newcategory"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="login" />;
                          } else {
                            return <NewCategory />;
                          }
                        }}
                      />
                      <Route
                        path="/manufacturers"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <ManufacturersDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/manufacturer"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Manufacturer />;
                          }
                        }}
                      />
                      <Route
                        path="/pages"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <PagesDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/page"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Page />;
                          }
                        }}
                      />
                      <Route
                        path="/specs"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <SpecsDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/posts"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <PostsDataView />;
                          }
                        }}
                      />
                      <Route
                        path="/post"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Post />;
                          }
                        }}
                      />
                      <Route
                        path="/orders"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Orders />;
                          }
                        }}
                      />
                      <Route
                        path="/banners"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Banners />;
                          }
                        }}
                      />
                      <Route
                        path="/settings"
                        render={() => {
                          if (
                            !Cookie.get("jwtToken") ||
                            Cookie.get("jwtToken") === "" ||
                            Cookie.get("expTime") < Date.now() / 1000
                          ) {
                            return <Redirect to="/login" />;
                          } else {
                            return <Settings />;
                          }
                        }}
                      />
                    </Switch>
                  </Content>
                </Layout>
              )}
            />
            <Footer style={{ textAlign: "center" }}>
              © 2019 - {new Date().getFullYear()} {packageJson.name} v
              {packageJson.version} <br /> Created by{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#faa535" }}
                href="https://owltechagency.com/"
              >
                Owltech Agency
              </a>
            </Footer>
          </Layout>
        </Layout>
      </div>
    </Router>
  </Suspense>
);

ReactDOM.render(routing, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
